export default "__VITE_ASSET__aeb0e806__"